export const VISIT_TABLE_VIEW = "visitTable";
export const VISIT_ORDER_VIEW = "visitOrders";
export const VISIT_FEEDBACK_VIEW = "visitFeedback";
export const VISIT_NOTES_VIEW = "visitNotes";
export const VISIT_PDFS_VIEW = "visitPdfs";
export const VISIT_CHAT_VIEW = "visitChat";